<form [formGroup]="form" (ngSubmit)="onSave()">
  <p-fluid>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 md:col-span-6">
      <div class="p-form-widget">
        <div class="field">
          <label class="pl-0">Referred:</label>
          <div class="p-field-checkbox-container">
            <p-checkbox binary="true" formControlName="referred"></p-checkbox>
          </div>
        </div>
      </div>
      <div class="field">
        <label>Date Referred:</label>
        <p-date-picker
          formControlName="referredDate"
          dateFormat="mm/dd/yy"
          appendTo="body"
          class="w-full"
          [showIcon]="true"
        ></p-date-picker>
      </div>
      <div class="p-form-widget">
        <div class="field">
          <label class="pl-0">Enrolled:</label>
          <div class="p-field-checkbox-container">
            <p-checkbox binary="true" formControlName="enrolled"></p-checkbox>
          </div>
        </div>
      </div>
      <div class="field">
        <label>Enrollment Date:</label>
        <p-date-picker
          formControlName="enrolledDate"
          dateFormat="mm/dd/yy"
          appendTo="body"
          class="w-full"
          [showIcon]="true"
        ></p-date-picker>
      </div>
      <div class="field">
        <label class="pr-2">Status:</label>
        <p-select
          placeholder="Select"
          formControlName="status"
          appendTo="body"
          [options]="aspireStatuses$ | async"
        ></p-select>
      </div>
      <div class="field">
        <label class="pr-2">Staging Status:</label>
        <p-select
          placeholder="Select"
          formControlName="stagingStatus"
          appendTo="body"
          [options]="aspireStagingStatuses$ | async"
        ></p-select>
      </div>
    </div>
    <div class="col-span-12 md:col-span-6">
      <div class="field">
        <label>Most Recent Assessment Date:</label>
        <p-date-picker
          formControlName="mostRecentAssessmentDate"
          dateFormat="mm/dd/yy"
          appendTo="body"
          class="w-full"
          [showIcon]="true"
        ></p-date-picker>
      </div>
      <div class="field">
        <label>Primary Diagnosis:</label>
        <input pInputText type="text" class="w-full" maxlength="100" formControlName="primaryDiagnosis" />
      </div>
      <div class="field">
        <label>Discharge Date:</label>
        <p-date-picker
          formControlName="dischargeDate"
          dateFormat="mm/dd/yy"
          appendTo="body"
          class="w-full"
          [showIcon]="true"
        ></p-date-picker>
      </div>
      <div class="field">
        <label class="pr-2">Discharge Reason:</label>
        <p-select
          placeholder="Select"
          formControlName="dischargeReason"
          appendTo="body"
          [options]="aspireDischargeReasons$ | async"
        ></p-select>
      </div>
      <div class="field">
        <label class="pr-2">Palliative Performance Scale (%):</label>
        <input
          pInputText
          type="number"
          min="0"
          max="100"
          maxlength="3"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          formControlName="palliativePerformanceScale"
          (input)="onPalliativePerformanceScaleInput($event)"
          />
          @if (form.controls['palliativePerformanceScale'].hasError('max')) {
            <span
              style="display: block;"
              class="error"
              >
              Maximum value is 100
            </span>
          }
          @if (form.controls['palliativePerformanceScale'].hasError('pattern')) {
            <span
              style="display: block;"
              class="error"
              >
              Only whole numbers are allowed
            </span>
          }
        </div>
      </div>
    </div>
</p-fluid>
    <div class="flex justify-end">
      <button
        pButton
        class="p-button-secondary mr-2"
        type="button"
        label="Cancel"
        (click)="onClose()"
      ></button>

      <button
        pButton
        type="submit"
        label="Save"
        [disabled]="!(form.dirty && form.valid)"
      ></button>
    </div>
  </form>

  <p-confirmDialog
    key="aspireCancelConfirmation"
    header="Info"
    appendTo="body"
    [closable]="false"
    rejectButtonStyleClass="p-button-info"
    rejectLabel="No"
    acceptLabel="Yes"
    >
    <ng-template pTemplate="message">
      <p>Are you sure you want to cancel the action?</p>
    </ng-template>
  </p-confirmDialog>
